import React from 'react'
import cn from 'classnames'

import styles from './OccasionItemSkeletons.module.css'

type RequestOccasionSkeletonProps = {
  limit: number
}
const OccasionItemSkeletons: React.FC<RequestOccasionSkeletonProps> = ({
  limit,
}) => {
  return (
    <div className={styles.wrapper}>
      {Array.from(Array(limit).keys()).map((i) => {
        const size = i % 2 ? 'long' : 'short'

        return (
          <div className={cn(styles.card, styles[`card-${size}`])} key={i} />
        )
      })}
    </div>
  )
}

export default OccasionItemSkeletons
